;(function module() {
  angular.module('app.ui.form.ctrls').controller('DatePickerController', [
    '$location',
    function controller($location) {
      let vm = this
      var allowedUrlsForMonthFormat = [
        '/profile',
        '/user-profile',
        '/profile#!',
        '/admin/lawyer-profile',
      ]
      let oldDate = new Date()
      vm.maxDate = new Date()
      vm.today = () => {
        vm.dt = new Date()
        vm.dt.setHours(24, 0, 0, 0)
        oldDate.setDate(oldDate.getDate() + 1)
      }

      vm.today()
      vm.showWeeks = true
      vm.toggleWeeks = () => {
        vm.showWeeks = !vm.showWeeks
        return vm.showWeeks
      }

      vm.clear = () => {
        vm.dt = undefined
        return vm.dt
      }

      // $location;
      // vm.disabled = (date, mode) => {
      //   if ($location.url() !== '/profile') {
      //     if (mode === 'month') {
      //       return mode === 'month' && date > vm.dt
      //     }

      //     if (mode === 'day') {
      //       return mode === 'day' && date < vm.dt
      //     }
      //   }
      // }

      vm.reverseDisabled = (date, mode) => {
        if ($location.url() !== '/profile') {
          if (mode === 'month') {
            return mode === 'month' && date < vm.dt
          }

          if (mode === 'day') {
            return mode === 'day' && date > oldDate
          }
        }
      }

      vm.toggleMin = () => {
        let reference
        vm.minDate =
          // eslint-disable-next-line no-negated-condition
          (reference = vm.minDate) !== undefined
            ? reference
            : {
                null: new Date(),
              }

        return vm.minDate
      }

      vm.toggleMin()

      vm.open = event => {
        event.preventDefault()
        event.stopPropagation()
        vm.opened = true
        return vm.opened
      }

      function isMonthFormatRequested(isMonthRequested) {
        return (
          _.contains(allowedUrlsForMonthFormat, $location.path()) ||
          isMonthRequested
        )
      }

      vm.setPickerStyle = isMonthRequested => {
        if (isMonthFormatRequested(isMonthRequested)) {
          vm.dateOptions = {
            'year-format': "'yy'",
            'starting-day': 1,
            'datepicker-mode': "'month'",
            'min-mode': 'month',
            defaultDate: '1',
          }
          vm.formats = ['MMMM-yyyy', 'yyyy/MM', 'shortDate']
        } else {
          vm.dateOptions = {
            'datepicker-mode': "'day'",
            'year-format': "'yy'",
            'starting-day': 1,
            defaultDate: '1',
          }
          vm.formats = ['dd-MMMM-yyyy', 'yyyy/MM', 'shortDate']
        }

        vm.format = vm.formats[0]
        return vm.format
      }

      vm.setPickerStyle()
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/directives/date-modal/date-picker.ctrl.js